import CardContainer from "../component/CardContainer"

const Library =()=>{
    return (
        <div className="bg">
            {/* <h1>Shop</h1> */}
            <CardContainer />

        </div>
    )
}

export default Library